<template>
  <div>
    <div class="d-flex flex-row-reverse">
      <v-menu bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab x-small color="secondary" dark v-bind="attrs" v-on="on">
            <v-icon dark>mdi-cog-outline</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item link @click="downloadCSV">
            <v-list-item-title>Download as CSV</v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="
              $router.replace({
                name: 'budgetView',
                params: { id },
                query: { edit: !edit }
              })
            "
          >
            <v-list-item-title>Toggle {{ action }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <table>
      <tr>
        <th></th>
        <th>Monthly</th>
        <th>Annually</th>
      </tr>
      <tr>
        <td class="category">Monthly Cash In</td>
        <td></td>
        <td></td>
      </tr>
      <tr class="row-border">
        <td>Funds from family</td>
        <td class="currency">
          <currency-field
            class="family-income"
            v-model="familyIncome"
            :edit="edit"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-family-income"
            :value="familyIncome * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>Earned income (job)</td>
        <td class="currency">
          <v-spacer /><currency-field
            class="earned-income"
            v-model="earnedIncome"
            :edit="edit"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-earned-income"
            :value="earnedIncome * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="total">
        <td class="total-header">Total</td>
        <td class="currency">
          <currency-field
            class="total-cash-in"
            :value="cashInTotal"
            :edit="false"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-total-cash-in"
            :value="cashInTotal * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td class="category">Monthly Cash Out</td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td class="sub-category">Food & Dining</td>
        <td></td>
        <td></td>
      </tr>
      <tr class="row-border">
        <td>Breakfast Out</td>
        <td class="currency">
          <currency-field class="breakfast" v-model="breakfast" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-breakfast"
            :value="breakfast * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>Lunch Out</td>
        <td class="currency">
          <currency-field class="lunch" v-model="lunch" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-lunch"
            :value="lunch * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>Dinner Out</td>
        <td class="currency">
          <currency-field class="dinner" v-model="dinner" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-dinner"
            :value="dinner * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>Groceries</td>
        <td class="currency">
          <currency-field class="groceries" v-model="groceries" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-groceries"
            :value="groceries * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="total">
        <td class="total-header">Total</td>
        <td class="currency">
          <currency-field class="total-food" :value="foodTotal" :edit="false" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-total-food"
            :value="foodTotal * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr>
        <td class="sub-category">Personal Care</td>
        <td></td>
        <td></td>
      </tr>
      <tr class="row-border">
        <td>Laundry</td>
        <td class="currency">
          <currency-field class="laundry" v-model="laundry" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-laundry"
            :value="laundry * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>Products (skincare, hair, personal hygiene,etc.)</td>
        <td class="currency">
          <currency-field class="products" v-model="products" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-products"
            :value="products * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>Makeup</td>
        <td class="currency">
          <currency-field class="makeup" v-model="makeup" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-makeup"
            :value="makeup * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>Medical / Rx</td>
        <td class="currency">
          <currency-field class="medical" v-model="medical" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-medical"
            :value="medical * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="total">
        <td class="total-header">Total</td>
        <td class="currency">
          <currency-field
            class="total-personal-care"
            :value="personalCareTotal"
            :edit="false"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-total-personal-care"
            :value="personalCareTotal * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr>
        <td class="sub-category">Transportation</td>
        <td></td>
        <td></td>
      </tr>
      <tr class="row-border">
        <td>Uber</td>
        <td class="currency">
          <currency-field class="ride-share" v-model="rideShare" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-ride-share"
            :value="rideShare * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>Public Transit</td>
        <td class="currency">
          <currency-field
            class="public-transit"
            v-model="publicTransit"
            :edit="edit"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-public-transit"
            :value="publicTransit * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>Gas</td>
        <td class="currency">
          <currency-field class="gas" v-model="gas" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-gas"
            :value="gas * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>Auto Expenses</td>
        <td class="currency">
          <currency-field class="auto" v-model="auto" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-auto"
            :value="auto * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="total">
        <td class="total-header">Total</td>
        <td class="currency">
          <currency-field
            class="total-transportation"
            :value="transportationTotal"
            :edit="false"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-total-transportation"
            :value="transportationTotal * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr>
        <td class="sub-category">Miscellaneous Living Expenses</td>
        <td></td>
        <td></td>
      </tr>
      <tr class="row-border">
        <td>Clothing</td>
        <td class="currency">
          <currency-field class="clothing" v-model="clothing" :edit="edit" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-clothing"
            :value="clothing * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>School Supplies</td>
        <td class="currency">
          <currency-field
            class="school-supplies"
            v-model="schoolSupplies"
            :edit="edit"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-school-supplies"
            :value="schoolSupplies * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>Entertainment (concerts, movies, music, etc.)</td>
        <td class="currency">
          <currency-field
            class="entertainment"
            v-model="entertainment"
            :edit="edit"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-entertainment"
            :value="entertainment * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>
          <v-text-field
            v-if="edit"
            class="custom-category cust-1-name"
            v-model="custOneName"
            placeholder="Other: Category 1"
          ></v-text-field>
          <div v-else>{{ custOneName }}</div>
        </td>
        <td class="currency">
          <currency-field
            class="cust-1-value"
            v-model="custOneValue"
            :edit="edit"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-cust-1-value"
            :value="custOneValue * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="row-border">
        <td>
          <v-text-field
            v-if="edit"
            class="custom-category cust-2-name"
            v-model="custTwoName"
            placeholder="Other: Category 2"
          ></v-text-field>
          <div v-else>{{ custTwoName }}</div>
        </td>
        <td class="currency">
          <currency-field
            class="cust-2-value"
            v-model="custTwoValue"
            :edit="edit"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-cust-2-value"
            :value="custTwoValue * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="total">
        <td class="total-header">Total</td>
        <td class="currency">
          <currency-field class="total-misc" :value="miscTotal" :edit="false" />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-total-misc"
            :value="miscTotal * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="monthly-total">
        <td class="total-header">Monthly Total</td>
        <td class="currency">
          <currency-field
            class="total-cash-out"
            :value="cashOutTotal"
            :edit="false"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-total-cash-out"
            :value="cashOutTotal * year"
            :edit="false"
          />
        </td>
      </tr>
      <tr class="saving">
        <td class="total-header">Net Savings/Short Fall</td>
        <td class="currency">
          <currency-field
            class="total-savings"
            :value="savings"
            :edit="false"
          />
        </td>
        <td class="currency">
          <currency-field
            class="yearly-total-savings"
            :value="savings * year"
            :edit="false"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import BadgeUpload from "@/containers/badges/BadgeUpload"
import { BadgesAPI } from "@/lib/api"
import eventMixin from "@/mixins/eventMixin"
import BaseList from "@/components/BaseList"
import CurrencyField from "@/components/CurrencyField"
import User from "@/lib/user"
import { apiConfig } from "@/lib/config"
import axios from "axios"

export default {
  mixins: [titleMixin],
  components: {
    CurrencyField
  },
  data: function() {
    return {
      year: 12
    }
  },
  computed: {
    id() {
      return this.$route.params.budgetId
    },
    title() {
      return this.budget ? this.budget.name : ""
    },
    edit() {
      let edit =
        this.$route.query.edit == "true" || this.$route.query.edit == true
      return edit
    },
    budget() {
      let budget = this.$store.getters["budgets/getBudgetById"](this.id)
      return budget ? budget : {}
    },
    csvBudget() {
      return this.budget
    },
    action() {
      return this.edit ? "View" : "Edit"
    },

    familyIncome: {
      get() {
        return this.budget.family_income
      },
      set(newValue) {
        this.update({ family_income: newValue })
      }
    },
    earnedIncome: {
      get() {
        return this.budget.earned_income
      },
      set(newValue) {
        this.update({ earned_income: newValue })
      }
    },
    cashInTotal() {
      return this.budget
        ? this.budget.family_income + this.budget.earned_income
        : 0
    },
    breakfast: {
      get() {
        return this.budget.breakfast
      },
      set(newValue) {
        this.update({ breakfast: newValue })
      }
    },
    lunch: {
      get() {
        return this.budget.lunch
      },
      set(newValue) {
        this.update({ lunch: newValue })
      }
    },
    dinner: {
      get() {
        return this.budget.dinner
      },
      set(newValue) {
        this.update({ dinner: newValue })
      }
    },
    groceries: {
      get() {
        return this.budget.groceries
      },
      set(newValue) {
        this.update({ groceries: newValue })
      }
    },
    foodTotal() {
      return this.budget
        ? this.breakfast + this.lunch + this.dinner + this.groceries
        : 0
    },
    laundry: {
      get() {
        return this.budget.laundry
      },
      set(newValue) {
        this.update({ laundry: newValue })
      }
    },
    products: {
      get() {
        return this.budget.products
      },
      set(newValue) {
        this.update({ products: newValue })
      }
    },
    makeup: {
      get() {
        return this.budget.makeup
      },
      set(newValue) {
        this.update({ makeup: newValue })
      }
    },
    medical: {
      get() {
        return this.budget.medical
      },
      set(newValue) {
        this.update({ medical: newValue })
      }
    },
    personalCareTotal() {
      return this.budget
        ? this.budget.laundry +
            this.budget.products +
            this.budget.makeup +
            this.budget.medical
        : 0
    },
    rideShare: {
      get() {
        return this.budget.ride_share
      },
      set(newValue) {
        this.update({ ride_share: newValue })
      }
    },
    publicTransit: {
      get() {
        return this.budget.public_transit
      },
      set(newValue) {
        this.update({ public_transit: newValue })
      }
    },
    gas: {
      get() {
        return this.budget.gas
      },
      set(newValue) {
        this.update({ gas: newValue })
      }
    },
    auto: {
      get() {
        return this.budget.auto
      },
      set(newValue) {
        this.update({ auto: newValue })
      }
    },
    transportationTotal() {
      return this.budget
        ? this.rideShare + this.publicTransit + this.gas + this.auto
        : 0
    },
    clothing: {
      get() {
        return this.budget.clothing
      },
      set(newValue) {
        this.update({ clothing: newValue })
      }
    },
    schoolSupplies: {
      get() {
        return this.budget.school_supplies
      },
      set(newValue) {
        this.update({ school_supplies: newValue })
      }
    },
    entertainment: {
      get() {
        return this.budget.entertainment
      },
      set(newValue) {
        this.update({ entertainment: newValue })
      }
    },
    custOneName: {
      get() {
        return this.budget.cust_1_name
      },
      set(newValue) {
        this.update({ cust_1_name: newValue })
      }
    },
    custOneValue: {
      get() {
        return this.budget.cust_1_value
      },
      set(newValue) {
        this.update({ cust_1_value: newValue })
      }
    },
    custTwoName: {
      get() {
        return this.budget.cust_2_name
      },
      set(newValue) {
        this.update({ cust_2_name: newValue })
      }
    },
    custTwoValue: {
      get() {
        return this.budget.cust_2_value
      },
      set(newValue) {
        this.update({ cust_2_value: newValue })
      }
    },
    // custThreeName: {
    //   get() {
    //     return this.budget.cust_3_name
    //   },
    //   set(newValue) {
    //     this.update({ cust_3_name: newValue })
    //   }
    // },
    // custThreeValue: {
    //   get() {
    //     return this.budget.cust_3_value
    //   },
    //   set(newValue) {
    //     this.update({ cust_3_value: newValue })
    //   }
    // },

    miscTotal() {
      return this.budget
        ? this.clothing +
            this.schoolSupplies +
            this.entertainment +
            this.custOneValue +
            this.custTwoValue
        : 0
    },
    cashOutTotal() {
      return this.budget
        ? this.foodTotal +
            this.personalCareTotal +
            this.transportationTotal +
            this.miscTotal
        : 0
    },
    savings() {
      return this.budget ? this.cashInTotal - this.cashOutTotal : 0
    }
  },
  methods: {
    update(payload) {
      this.$store.dispatch("budgets/updateBudget", {
        id: this.id,
        payload: payload
      })
    },
    async downloadCSV() {
      let response = await axios.get(
        `/budgets/${this.id}/export_csv`,
        apiConfig
      )

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", "budget.csv")
      document.body.appendChild(link)
      link.click()
    }
  },
  created() {
    this.$store.dispatch("budgets/loadBudget", { id: this.id })
  }
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";
@import "../../../scss/buttons";
table {
  width: 100%;
  border-collapse: collapse;
}
th {
  text-align: right;
}
tr {
  height: 40px;
}
.currency {
  max-width: 80px;
}
.custom-category {
  max-width: 200px;
}
.category {
  font-weight: bold;
  font-size: 18px;
}
.sub-category {
  font-weight: bold;
  font-size: 16px;
}
.total {
  font-weight: bold;
}
.monthly-total {
  font-weight: bold;
}
.saving {
  font-weight: bold;
  border: 1px solid black;
}
.currency {
  text-align: right;
  min-width: 80px;
}
.total-header {
  text-align: right;
}
</style>
